export enum LandingTestHooks {
  GuestCheckoutButton = 'guest-checkout-button',
  GuestCheckoutDescription = 'guest-checkout-description',
  GuestCheckoutTitle = 'guest-checkout-title',
  LoggedInCheckoutButton = 'logged-in-checkout-button',
  LoggedInCheckoutDescription = 'logged-in-checkout-description',
  LoggedInCheckoutForm = 'logged-in-checkout-form',
  LoggedInCheckoutEmailInput = 'logged-in-checkout-email-input__text',
  LoggedInCheckoutPasswordInput = 'logged-in-checkout-password-input__text',
  LoggedInCheckoutTitle = 'logged-in-checkout-title',
}
